const descriptions = [
    {
        id: 'agriculture_biologique',
        description: `
            Agriculture Biologique (AB) er et fransk økologisk sertifiseringsmerke som indikerer at produktet er produsert i samsvar med økologiske standarder. Produktet må inneholde minst 95% økologikse ingredienser, produsert eller prosessert i EU, og ble sertifisert.
            <br><br>
            <a href="https://icea.bio/ab-france/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Agriculture Biologique her</a>
        `
    },
    {
        id: 'asc',
        description: `
            ASC (Aquaculture Stewardship Council) er et symbol som indikerer at produktet er sertifisert i henhold til bærelraftig produksjon globalt. Med ASC-merket stilles det krav til at oppdrettet har en bevisst policy på å redusere skader på miljøet.
            <br><br>
            <a href="https://www.asc-aqua.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om ASC her</a>
        `
    },
    {
        id: 'avfall_papp',
        description: `
            Avfall papp er et symbol som indikerer at produktet er laget av papp og skal kastes i papp/papiravfallet.
        `
    },
    {
        id: 'avfall_plastemballasje',
        description: `
            Avfall plastemballasje er et symbol som indikerer at produktet er laget av plast og skal kastes i plastavfallet.
        `
    },
    {
        id: 'beskyttedebetegnelser',
        description: `
            Beskyttede betegnelser er en offentlig merkeordning som gir lovbeskyttelse til navn på tradisjonelle matprodukter med særpreg og klar tilhørighet til et bestemt geografisk område.
            <br><br>
            <a href="https://www.beskyttedebetegnelser.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om beskyttede betegnelser her</a>
        `
    },
    {
        id: 'blomsten',
        description: `
            Blomsten er det europeiske økologiske sertifiseringsmerket. Produsent må dokumentere at produktet tilfredsstiller en rekke strenge helse- og miljøkrav. EUs Ecolabel er et tilsvarende miljømerke som Svanemerket.
            <br><br>
            <a href="https://ec.europa.eu/info/food-farming-fisheries/farming/organic-farming/organic-logo_en" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om det europeiske økologiske sertifiseringsmerket her</a>
        `
    },
    {
        id: 'bramiljoval',
        description: `
            Bra Miljöval er et svensk miljøsertifiseringsmerke som indikerer at produktet er produsert i samsvar med svenske naturvernsforeningen sine miljøkrav.
            <br><br>
            <a href="https://www.braMiljoval.se/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Bra Miljöval her</a>
        `
    },
    {
        id: 'brodskalaen_ekstragrovt',
        description: `
            Brødskala'n Ekstragrovt er et symbol som indikerer at brødet er laget av ekstra grovt mel, som inneholder en høyere andel fullkorn og fiber enn vanlig brød. Det betyr at brødet er mer næringsrikt og kan bidra til bedre fordøyelse og økt metthetsfølelse.
            <br><br>
            <a href="https://www.bklf.no/brodskalan--spis-litt-grovere/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Brødskala'n her</a>
        `
    },
    {
        id: 'brodskalaen_fint',
        description: `
            Brødskala'n Fint er et symbol som indikerer at brødet er laget av fint mel, som inneholder en lavere andel fullkorn og fiber enn grovt brød. Det betyr at brødet er mindre næringsrikt og kan ha lavere metthetsfølelse.
            <br><br>
            <a href="https://www.bklf.no/brodskalan--spis-litt-grovere/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Brødskala'n her</a>
        `
    },
    {
        id: 'brodskalaen_grovt',
        description: `
            Brødskala'n Grovt er et symbol som indikerer at brødet er laget av grovt mel, som inneholder en høyere andel fullkorn og fiber enn fint brød. Det betyr at brødet er mer næringsrikt og kan bidra til bedre fordøyelse og økt metthetsfølelse.
            <br><br>
            <a href="https://www.bklf.no/brodskalan--spis-litt-grovere/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Brødskala'n her</a>
        `
    },
    {
        id: 'brodskalaen_halvgrovt',
        description: `
            Brødskala'n Halvgrovt er et symbol som indikerer at brødet er laget av halvgrovt mel, som inneholder en moderat andel fullkorn og fiber. Det betyr at brødet har en balansert næringsprofil og kan bidra til bedre fordøyelse og metthetsfølelse sammenlignet med fint brød.
            <br><br>
            <a href="https://www.bklf.no/brodskalan--spis-litt-grovere/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Brødskala'n her</a>
        `
    },
    {
        id: 'ce_merket',
        description: `
            CE-merket betyr at produsenten garanterer at grunnleggende sikkerhetskrav for produktet er oppfylt og kan dokumenteres. CE-merket sier ikke noe om kvalitetsaspekter ved produktet. Merket betyr heller ikke at produktet er kontrollert av myndighetene.
            <br><br>
            <a href="https://ec.europa.eu/growth/single-market/ce-marking_en" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om CE-merket her</a>
        `
    },
    {
        id: 'crossed_grain',
        description: `
            Crossed Grain er et symbol som indikerer at produktet er garantert glutenfritt.
        `
    },
    {
        id: 'demeter',
        description: `
            Demeter er et symbol som indikerer at produktet kommer fra sertifisert biodynamisk landbruk.
            <br><br>
            <a href="https://www.demeter.net/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Demeter her</a>
        `
    },
    {
        id: 'drikkekartong',
        description: `
            Drikkekartong er et symbol som indikerer at produktet er laget av kartong og skal kastes i papp/papiravfallet.
        `
    },
    {
        id: 'dyrevernmerket',
        description: `
            Dyrevernmerket er et symbol som indikerer at produktet er produsert med strengere dyrevelferd enn minimumskravene i offentlig regelverk.
            <br><br>
            <a href="https://www.dyrevern.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Dyrevernmerket her</a>
        `
    },
    {
        id: 'e_merket',
        description: `
            E-merket er et symbol som indikerer at produktet inneholder minst like mye som angitt på pakken.
        `
    },
    {
        id: 'ecocert',
        description: `
            Ecocert er i utgangspunktet en fransk merkeordning som garanterer for at en vare er økologisk dyrket, men opererer nå i en rekke land.
            <br><br>
            <a href="https://www.ecocert.com/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Ecocert her</a>
        `
    },
    {
        id: 'ethical_tea_partnership',
        description: `
            Ethical Tea Partnership er et symbol som indikerer at produktet er produsert i samsvar med strenge miljømessige, sosiale og økonomiske standarder for teproduksjon.
            <br><br>
            <a href="https://etp-global.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Ethical Tea Partnership her</a>
        `
    },
    {
        id: 'eus_okologimerke',
        description: `
            EU's økologiske merke betyr at en vare er verifisert som organisk. Det innebærer at produsent har oppfylt strenge krav til produksjon, prosessering, transport og lagring.
            <br><br>
            <a href="https://agriculture.ec.europa.eu/farming/organic-farming/organic-logo_en" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om EU's økologiske merke her</a>
        `
    },
    {
        id: 'fairtrade',
        description: `
            Fairtrade er en internasjonal merkeordning som styrker bønder og arbeidere i fattige land gjennom rettferdig handel. Fairtrade-standardene bedrer arbeidsforhold og handelsbetingelser, og gjør det mulig å investere i produksjon, lokalsamfunn og en bærekraftig framtid.
            <br><br>
            <a href="https://www.fairtrade.net/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Fairtrade her</a>
        `
    },
    {
        id: 'fsc',
        description: `
            FSC (Forest Stewardship Council) merket stiller krav om at skogdriften ikke fører til avskoging, at hogsten foregår kontrollert, og at den tar hensyn til lokalbefolkningen.
            <br><br>
            <a href="https://fsc.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om FSC her</a>`
    },
    {
        id: 'glass_og_gaffelsymbolet',
        description: `
            Glass- og gaffelsymbolet er et internasjonalt symbol som viser at produktet er egnet for kontakt med mat.
            <br><br>
            Det betyr at materialet i emballasjen ikke vil avgi skadelige stoffer til maten, og at det er trygt å bruke for oppbevaring og servering av matvarer.`
    },
    {
        id: 'glassemballasje',
        description: `
            Glassemballasje er et symbol som indikerer at produktet er laget av glass og skal kastes i glassavfallet.
        `
    },
    {
        id: 'godt_lokalt',
        description: `
            Godt Lokalt er et symbol som indikerer at produktet er produsert lokalt. Lokalmat er «herfra» og opplevelsen av «herfra» er forankret i tradisjoner, identitet og lokal matkultur.
            <br><br>
            <a href="https://www.godtlokalt.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Godt Lokalt her</a>
        `
    },
    {
        id: 'grontpunkt',
        description: `
            Grønt Punkt på emballasjen viser at produsenten/importøren deltar i finansieringen av en nasjonal ordning som sikrer at kildesortert emballasje går til gjenvinning.
            <br><br>
            <a href="https://www.grontpunkt.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Grønt Punkt her</a>`
    },
    {
        id: 'klodemerket',
        description: `
            Klodemerket er et symbol som indikerer at produktet er produsert med hensyn til miljøet og bærekraft.
            <br><br>
            <a href="https://www.toro.no/hva-betyr-klodemerket/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Klodemerket her</a>
        `
    },
    {
        id: 'krav',
        description: `
            KRAV er det svenske merket for økologisk produksjon. KRAV-merket gir en garanti for at en vare er økologisk dyrket. Merket setter krav til at det ikke brukes kunstgjødsel eller syntetiske sprøytemidler i produksjonen. KRAV-merket har i tillegg til EU-kravene til økologisk produksjon også egne høye krav til biologisk mangfold, redusert klimaavtrykk, god dyrevelferd og gode arbeidsvilkår.
            <br><br>
            <a href="https://www.krav.se/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om KRAV her</a>
        `
    },
    {
        id: 'kvalitetssystem_i_landbruket',
        description: `
            KSL (Kvalitetssystem i landbruket) garanterer at produktet er produsert, bearbeidet og pakket i Norge, og at det oppfyller strenge kvalitetskrav.
            <br><br>
            <a href="https://www.ksl.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om KSL her</a>
        `
    },
    {
        id: 'metallemballasje',
        description: `
            Metallemballasje er et symbol som indikerer at produktet er laget av metall og skal kastes i metallavfallet.
        `
    },
    {
        id: 'msc',
        description: `
            Marine Stewardship Council (MSC) er et miljømerke for fisk og sjømatprodukter. Merket garanterer at produktet kommer fra bærekraftig fiske.
            <br><br>
            <a href="https://www.msc.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om MSC her</a>
        `
    },
    {
        id: 'myk_plastemballasje',
        description: `
            Myk plastemballasje er et symbol som indikerer at produktet er laget av myk plast og skal kastes i plastavfallet.
        `
    },
    {
        id: 'naaf',
        description: `
            NAAF (Norges Astma- og Allergiforbund) er et symbol som indikerer at produktet er allergivennlig og egnet for personer med astma eller allergi.
            <br><br>
            <a href="https://www.naaf.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om NAAF her</a>
        `
    },
    {
        id: 'nokkelhullet',
        description: `
            Nøkkelhullet er en offentlig merkeordning for matvarer. Merkeordningen skal gjøre det enkelt å velge sunnere matvarer som inneholder mer kostfiber og mindre fett, sukker og salt.
            <br><br>
            <a href="https://www.helsenorge.no/kosthold-og-ernaring/nokkelhullet/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Nøkkelhullet her</a>
        `
    },
    {
        id: 'nyt_norge',
        description: `
            Nyt Norge er et symbol som indikerer at produktet er produsert i Norge og oppfyller strenge krav til kvalitet og sporbarhet. Det betyr at produsenten har forpliktet seg til å sikre at produktene er laget med norske råvarer og i samsvar med norske produksjonsstandarder.
            <br><br>
            <a href="https://www.nytnorge.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Nyt Norge her</a>
        `
    },
    {
        id: 'omerket',
        description: `
            Ø-merket er det offisielle norske økologimerket og gir en garanti for at en vare er økologisk dyrket.
            <br><br>
            <a href="https://www.forbrukerradet.no/merkeoversikten/etikk/o-merket/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Ø-merket her</a>
        `
    },
    {
        id: 'papir',
        description: `
            Papir er et symbol som indikerer at produktet er laget av papir og skal kastes i papp/papiravfallet.
        `
    },
    {
        id: 'papp',
        description: `
            Papp er et symbol som indikerer at produktet er laget av papp og skal kastes i papp/papiravfallet.
        `
    },
    {
        id: 'pefc_sertifisert',
        description: `
            PEFC (Programme for the Endorsement of Forest Certification) er et symbol som indikerer at produktet er laget av tre eller papir som kommer fra ansvarlig forvaltede skoger. Det betyr at produsenten har forpliktet seg til å beskytte skogsmiljøet og bevare biologisk mangfold.
            <br><br>
            <a href="https://pefc.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om PEFC her</a>
        `
    },
    {
        id: 'plast_i_produktet_drikkebegre',
        description: `
            Plast i produktet drikkebeger er et symbol som indikerer at produktet inneholder plast og skal kastes i plastavfallet.
        `
    },
    {
        id: 'plast_i_produktet1',
        description: `
            Plast i produktet 1 er et symbol som indikerer at produktet inneholder plast og skal kastes i plastavfallet.
        `
    },
    {
        id: 'plastemballasje',
        description: `
            Plastemballasje er et symbol som indikerer at produktet er laget av plast og skal kastes i plastavfallet.
        `
    },
    {
        id: 'plastpiler_1',
        description: `
            Plastpiler med tallet 1 indikerer at produktet er laget av polyetylen tereftalat (PET).
        `
    },
    {
        id: 'plastpiler_2',
        description: `
            Plastpiler med tallet 2 indikerer at produktet er laget av høy tetthet polyetylen (HDPE).
        `
    },
    {
        id: 'plastpiler_4',
        description: `
            Plastpiler med tallet 4 indikerer at produktet er laget av lav tetthet polyetylen (LDPE).
        `
    },
    {
        id: 'plastpiler_5',
        description: `
            Plastpiler med tallet 5 indikerer at produktet er laget av polypropylen (PP).
        `
    },
    {
        id: 'plastpiler_6',
        description: `
            Plastpiler med tallet 6 indikerer at produktet er laget av polystyren (PS).
        `
    },
    {
        id: 'plastpiler_7',
        description: `
            Plastpiler med tallet 7 indikerer at produktet er laget av andre typer plast som ikke faller inn under kategoriene 1-6.
        `
    },
    {
        id: 'rainforest_alliance_certified',
        description: `
            Rainforest Alliance Certified er et symbol som indikerer at det er tatt miljø- og bærekraftshensyn under produksjonen. Merket garanterer at 90 prosent av råvarene til produktet (med unntak av urte-te) må være sertifisert.
            <br><br>
            <a href="https://www.rainforest-alliance.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Rainforest Alliance her</a>
        `
    },
    {
        id: 'restavfall',
        description: `
            Restavfall er et symbol som indikerer at produktet ikke kan resirkuleres og skal kastes i restavfallet.
        `
    },
    {
        id: 'rspo',
        description: `
            RSPO (Roundtable on Sustainable Palm Oil) er et symbol som indikerer at produktet inneholder palmeolje som er produsert i samsvar med strenge miljømessige, sosiale og økonomiske standarder for bærekraftig palmeoljeproduksjon. Det betyr at produsenten har forpliktet seg til å beskytte regnskogen, bevare biologisk mangfold, og støtte rettferdige arbeidsforhold for arbeidere og lokalsamfunn.
            <br><br>
            <a href="https://rspo.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om RSPO her</a>
        `
    },
    {
        id: 'soil_association',
        description: `
            Soil Association er et symbol som indikerer at produktet er produsert i samsvar med strenge økologiske standarder. Det betyr at produsenten har forpliktet seg til å bruke naturlige metoder for jordbruk, unngå syntetiske kjemikalier og kunstgjødsel, og fremme biologisk mangfold.
            <br><br>
            <a href="https://www.soilassociation.org/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Soil Association her</a>
        `
    },
    {
        id: 'spesialitet',
        description: `
            Spesialitet er merkeordningen som viser vei til det beste av lokalmat og -drikke i Norge.
            <br><br>
            En uavhengig fagjury med høy matfaglig kompetanse bestemmer hvilke produkter som har høy nok kvalitet til å være kvalifisert til ordningen.
        `
    },
    {
        id: 'statskontrollert_okologisk',
        description: `
            Merket garanterer at en vare er økologisk dyrket. Det innebærer blant annet at det ikke brukes kunstgjødsel eller syntetiske sprøytemidler i produksjonen, og at krav til dyrevelferd er strengere enn i vanlig landbruk. Merket stiller også strenge krav til tilsetningsstoffer.
            <br><br>
            <a href="https://foedevarestyrelsen.dk/kost-og-foedevarer/oekologi/oekologi-for-foedevarevirksomheder/maerkning-og-sammensaetning/oe-maerket" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Statkontrollert økologisk her</a>
        `
    },
    {
        id: 'svanen',
        description: `
            Svanemerket er det offisielle nordiske miljømerket. Svanen stiller miljøkrav til produkter i et livssyklusperspektiv, fra uttak av råvare, under produksjon, under bruk og til produktet som avfall.
            <br><br>
            <a href="https://svanemerket.no/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Svanemerket her</a>
        `
    },
    {
        id: 'trygge_tekstiler_oko_tex',
        description: `
            Produkter merket med Trygge Tekstiler skal ikke inneholde allergifremkallende fargestoffer eller kreftfremkallende fargestoffer.
            <br><br>
            <a href="https://www.oeko-tex.com/en/our-standards/oeko-tex-standard-100" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Trygge Tekstiler her</a>
        `
    },
    {
        id: 'utz_certified',
        description: `
            UTZ Certified er et symbol som indikerer at produktet er produsert med bærekraftige metoder som tar hensyn til miljøet og sosiale forhold. Det betyr at produsenten har forpliktet seg til å redusere miljøpåvirkningen, bevare biologisk mangfold, og støtte rettferdige arbeidsforhold for arbeidere og lokalsamfunn.
            <br><br>
            <a href="https://www.rainforest-alliance.org/utz/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om UTZ Certified her</a>
        `
    },
    {
        id: 'v_label',
        description: `
            V-Label er et symbol som indikerer at produktet er vegansk. Det betyr at produktet ikke inneholder ingredienser av animalsk opprinnelse, og at det ikke har vært testet på dyr.
            <br><br>
            <a href="https://www.v-label.com/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om V-Label her</a>
        `
    },
    {
        id: 'vegan_society',
        description: `
            Vegan Society er et symbol som indikerer at produktet er vegansk. Det betyr at produktet ikke inneholder ingredienser av animalsk opprinnelse, og at det ikke har vært testet på dyr.
            <br><br>
            <a href="https://www.vegansociety.com/" target="_blank" rel="noopener noreferrer" style="font-weight: 500;">Les mer om Vegan Society her</a>
        `
    }
];

export function getBrandSchemeDescription(id: string): string | undefined {
    return descriptions.find(x => x.id === id)?.description;
}
